import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      value: null
    };
  },
  methods: {
    openAffiliateDetail() {
      if (this.params.context.componentParent.$refs.affiliateDetailModal) {
        this.params.context.componentParent.$refs.affiliateDetailModal.openAffiliateDetail(this.params.data.id);
      } else {
        this.params.context.componentParent.openAffiliateDetail(this.params.data.id);
      }
    }
  },
  template: `
        <span class="no-underline hover:underline cursor-pointer" v-on:click="openAffiliateDetail">
            {{this.params.value}}
        </span>
    `
});
